const currencyFormatter = require('currency-formatter');

const SUPPORTED_CURRENCIES = [
  'AED',
  'AUD',
  'AWG',
  'BHD',
  'CAD',
  'EUR',
  'NZD',
  'QAR',
  'SAR',
  'SGD',
  'USD',
  'ZAR',
  'GBP',
  'SEK',
  'DKK',
  'KES',
  'INR',
  'NOK',
  'ARS',
  'BRL',
  'CNY',
  'IDR',
  'JPY',
  'MXN',
  'ZAR',
  'TRY',
  'RUB',
  'KRW',
  'CHF',
  'ISK',
  'HKD',
  'PHP',
  'CZK',
  'PLN',
  'MYR',
  'VUV',
  'SCR',
  'BBD',
  'KWD',
  'MZN',
  'JMD',
  'DZD',
  'XOF',
  'BWP',
  'ILS',
  'COP'
];

export const INTL_UNSUPPORTED_CURRENCIES = [
  'ISK',
  'HKD',
  'VUV',
  'SCR',
  'KWD',
  'MZN',
  'JMD',
  'DZD',
  'AWG'
];

export const ALL_CURRENCY_LIST = [
  {
    code: 'AED',
    number: '784',
    digits: 2,
    currency: 'UAE Dirham',
    countries: ['United Arab Emirates (The)']
  },
  {
    code: 'AFN',
    number: '971',
    digits: 2,
    currency: 'Afghani',
    countries: ['Afghanistan']
  },
  {
    code: 'ALL',
    number: '008',
    digits: 2,
    currency: 'Lek',
    countries: ['Albania']
  },
  {
    code: 'AMD',
    number: '051',
    digits: 2,
    currency: 'Armenian Dram',
    countries: ['Armenia']
  },
  {
    code: 'ANG',
    number: '532',
    digits: 2,
    currency: 'Netherlands Antillean Guilder',
    countries: ['Curaçao', 'Sint Maarten (Dutch Part)']
  },
  {
    code: 'AOA',
    number: '973',
    digits: 2,
    currency: 'Kwanza',
    countries: ['Angola']
  },
  {
    code: 'ARS',
    number: '032',
    digits: 2,
    currency: 'Argentine Peso',
    countries: ['Argentina']
  },
  {
    code: 'AUD',
    number: '036',
    digits: 2,
    currency: 'Australian Dollar',
    countries: [
      'Australia',
      'Christmas Island',
      'Cocos (Keeling) Islands (The)',
      'Heard Island and Mcdonald Islands',
      'Kiribati',
      'Nauru',
      'Norfolk Island',
      'Tuvalu'
    ]
  },
  {
    code: 'AWG',
    number: '533',
    digits: 2,
    currency: 'Aruban Florin',
    countries: ['Aruba']
  },
  {
    code: 'AZN',
    number: '944',
    digits: 2,
    currency: 'Azerbaijan Manat',
    countries: ['Azerbaijan']
  },
  {
    code: 'BAM',
    number: '977',
    digits: 2,
    currency: 'Convertible Mark',
    countries: ['Bosnia and Herzegovina']
  },
  {
    code: 'BBD',
    number: '052',
    digits: 2,
    currency: 'Barbados Dollar',
    countries: ['Barbados']
  },
  {
    code: 'BDT',
    number: '050',
    digits: 2,
    currency: 'Taka',
    countries: ['Bangladesh']
  },
  {
    code: 'BGN',
    number: '975',
    digits: 2,
    currency: 'Bulgarian Lev',
    countries: ['Bulgaria']
  },
  {
    code: 'BHD',
    number: '048',
    digits: 3,
    currency: 'Bahraini Dinar',
    countries: ['Bahrain']
  },
  {
    code: 'BIF',
    number: '108',
    digits: 0,
    currency: 'Burundi Franc',
    countries: ['Burundi']
  },
  {
    code: 'BMD',
    number: '060',
    digits: 2,
    currency: 'Bermudian Dollar',
    countries: ['Bermuda']
  },
  {
    code: 'BND',
    number: '096',
    digits: 2,
    currency: 'Brunei Dollar',
    countries: ['Brunei Darussalam']
  },
  {
    code: 'BOB',
    number: '068',
    digits: 2,
    currency: 'Boliviano',
    countries: ['Bolivia (Plurinational State Of)']
  },
  {
    code: 'BOV',
    number: '984',
    digits: 2,
    currency: 'Mvdol',
    countries: ['Bolivia (Plurinational State Of)']
  },
  {
    code: 'BRL',
    number: '986',
    digits: 2,
    currency: 'Brazilian Real',
    countries: ['Brazil']
  },
  {
    code: 'BSD',
    number: '044',
    digits: 2,
    currency: 'Bahamian Dollar',
    countries: ['Bahamas (The)']
  },
  {
    code: 'BTN',
    number: '064',
    digits: 2,
    currency: 'Ngultrum',
    countries: ['Bhutan']
  },
  {
    code: 'BWP',
    number: '072',
    digits: 2,
    currency: 'Pula',
    countries: ['Botswana']
  },
  {
    code: 'BYN',
    number: '933',
    digits: 2,
    currency: 'Belarusian Ruble',
    countries: ['Belarus']
  },
  {
    code: 'BZD',
    number: '084',
    digits: 2,
    currency: 'Belize Dollar',
    countries: ['Belize']
  },
  {
    code: 'CAD',
    number: '124',
    digits: 2,
    currency: 'Canadian Dollar',
    countries: ['Canada']
  },
  {
    code: 'CDF',
    number: '976',
    digits: 2,
    currency: 'Congolese Franc',
    countries: ['Congo (The Democratic Republic of The)']
  },
  {
    code: 'CHE',
    number: '947',
    digits: 2,
    currency: 'WIR Euro',
    countries: ['Switzerland']
  },
  {
    code: 'CHF',
    number: '756',
    digits: 2,
    currency: 'Swiss Franc',
    countries: ['Liechtenstein', 'Switzerland']
  },
  {
    code: 'CHW',
    number: '948',
    digits: 2,
    currency: 'WIR Franc',
    countries: ['Switzerland']
  },
  {
    code: 'CLF',
    number: '990',
    digits: 4,
    currency: 'Unidad de Fomento',
    countries: ['Chile']
  },
  {
    code: 'CLP',
    number: '152',
    digits: 0,
    currency: 'Chilean Peso',
    countries: ['Chile']
  },
  {
    code: 'CNY',
    number: '156',
    digits: 2,
    currency: 'Yuan Renminbi',
    countries: ['China']
  },
  {
    code: 'COP',
    number: '170',
    digits: 2,
    currency: 'Colombian Peso',
    countries: ['Colombia']
  },
  {
    code: 'COU',
    number: '970',
    digits: 2,
    currency: 'Unidad de Valor Real',
    countries: ['Colombia']
  },
  {
    code: 'CRC',
    number: '188',
    digits: 2,
    currency: 'Costa Rican Colon',
    countries: ['Costa Rica']
  },
  {
    code: 'CUC',
    number: '931',
    digits: 2,
    currency: 'Peso Convertible',
    countries: ['Cuba']
  },
  {
    code: 'CUP',
    number: '192',
    digits: 2,
    currency: 'Cuban Peso',
    countries: ['Cuba']
  },
  {
    code: 'CVE',
    number: '132',
    digits: 2,
    currency: 'Cabo Verde Escudo',
    countries: ['Cabo Verde']
  },
  {
    code: 'CZK',
    number: '203',
    digits: 2,
    currency: 'Czech Koruna',
    countries: ['Czechia']
  },
  {
    code: 'DJF',
    number: '262',
    digits: 0,
    currency: 'Djibouti Franc',
    countries: ['Djibouti']
  },
  {
    code: 'DKK',
    number: '208',
    digits: 2,
    currency: 'Danish Krone',
    countries: ['Denmark', 'Faroe Islands (The)', 'Greenland']
  },
  {
    code: 'DOP',
    number: '214',
    digits: 2,
    currency: 'Dominican Peso',
    countries: ['Dominican Republic (The)']
  },
  {
    code: 'DZD',
    number: '012',
    digits: 2,
    currency: 'Algerian Dinar',
    countries: ['Algeria']
  },
  {
    code: 'EGP',
    number: '818',
    digits: 2,
    currency: 'Egyptian Pound',
    countries: ['Egypt']
  },
  {
    code: 'ERN',
    number: '232',
    digits: 2,
    currency: 'Nakfa',
    countries: ['Eritrea']
  },
  {
    code: 'ETB',
    number: '230',
    digits: 2,
    currency: 'Ethiopian Birr',
    countries: ['Ethiopia']
  },
  {
    code: 'EUR',
    number: '978',
    digits: 2,
    currency: 'Euro',
    countries: [
      'Åland Islands',
      'Andorra',
      'Austria',
      'Belgium',
      'Cyprus',
      'Estonia',
      'European Union',
      'Finland',
      'France',
      'French Guiana',
      'French Southern Territories (The)',
      'Germany',
      'Greece',
      'Guadeloupe',
      'Holy See (The)',
      'Ireland',
      'Italy',
      'Latvia',
      'Lithuania',
      'Luxembourg',
      'Malta',
      'Martinique',
      'Mayotte',
      'Monaco',
      'Montenegro',
      'Netherlands (The)',
      'Portugal',
      'Réunion',
      'Saint Barthélemy',
      'Saint Martin (French Part)',
      'Saint Pierre and Miquelon',
      'San Marino',
      'Slovakia',
      'Slovenia',
      'Spain'
    ]
  },
  {
    code: 'FJD',
    number: '242',
    digits: 2,
    currency: 'Fiji Dollar',
    countries: ['Fiji']
  },
  {
    code: 'FKP',
    number: '238',
    digits: 2,
    currency: 'Falkland Islands Pound',
    countries: ['Falkland Islands (The) [Malvinas]']
  },
  {
    code: 'GBP',
    number: '826',
    digits: 2,
    currency: 'Pound Sterling',
    countries: [
      'Guernsey',
      'Isle of Man',
      'Jersey',
      'United Kingdom of Great Britain and Northern Ireland (The)'
    ]
  },
  {
    code: 'GEL',
    number: '981',
    digits: 2,
    currency: 'Lari',
    countries: ['Georgia']
  },
  {
    code: 'GHS',
    number: '936',
    digits: 2,
    currency: 'Ghana Cedi',
    countries: ['Ghana']
  },
  {
    code: 'GIP',
    number: '292',
    digits: 2,
    currency: 'Gibraltar Pound',
    countries: ['Gibraltar']
  },
  {
    code: 'GMD',
    number: '270',
    digits: 2,
    currency: 'Dalasi',
    countries: ['Gambia (The)']
  },
  {
    code: 'GNF',
    number: '324',
    digits: 0,
    currency: 'Guinean Franc',
    countries: ['Guinea']
  },
  {
    code: 'GTQ',
    number: '320',
    digits: 2,
    currency: 'Quetzal',
    countries: ['Guatemala']
  },
  {
    code: 'GYD',
    number: '328',
    digits: 2,
    currency: 'Guyana Dollar',
    countries: ['Guyana']
  },
  {
    code: 'HKD',
    number: '344',
    digits: 2,
    currency: 'Hong Kong Dollar',
    countries: ['Hong Kong']
  },
  {
    code: 'HNL',
    number: '340',
    digits: 2,
    currency: 'Lempira',
    countries: ['Honduras']
  },
  {
    code: 'HRK',
    number: '191',
    digits: 2,
    currency: 'Kuna',
    countries: ['Croatia']
  },
  {
    code: 'HTG',
    number: '332',
    digits: 2,
    currency: 'Gourde',
    countries: ['Haiti']
  },
  {
    code: 'HUF',
    number: '348',
    digits: 2,
    currency: 'Forint',
    countries: ['Hungary']
  },
  {
    code: 'IDR',
    number: '360',
    digits: 2,
    currency: 'Rupiah',
    countries: ['Indonesia']
  },
  {
    code: 'ILS',
    number: '376',
    digits: 2,
    currency: 'New Israeli Sheqel',
    countries: ['Israel']
  },
  {
    code: 'INR',
    number: '356',
    digits: 2,
    currency: 'Indian Rupee',
    countries: ['Bhutan', 'India']
  },
  {
    code: 'IQD',
    number: '368',
    digits: 3,
    currency: 'Iraqi Dinar',
    countries: ['Iraq']
  },
  {
    code: 'IRR',
    number: '364',
    digits: 2,
    currency: 'Iranian Rial',
    countries: ['Iran (Islamic Republic Of)']
  },
  {
    code: 'ISK',
    number: '352',
    digits: 0,
    currency: 'Iceland Krona',
    countries: ['Iceland']
  },
  {
    code: 'JMD',
    number: '388',
    digits: 2,
    currency: 'Jamaican Dollar',
    countries: ['Jamaica']
  },
  {
    code: 'JOD',
    number: '400',
    digits: 3,
    currency: 'Jordanian Dinar',
    countries: ['Jordan']
  },
  {
    code: 'JPY',
    number: '392',
    digits: 0,
    currency: 'Yen',
    countries: ['Japan']
  },
  {
    code: 'KES',
    number: '404',
    digits: 2,
    currency: 'Kenyan Shilling',
    countries: ['Kenya']
  },
  {
    code: 'KGS',
    number: '417',
    digits: 2,
    currency: 'Som',
    countries: ['Kyrgyzstan']
  },
  {
    code: 'KHR',
    number: '116',
    digits: 2,
    currency: 'Riel',
    countries: ['Cambodia']
  },
  {
    code: 'KMF',
    number: '174',
    digits: 0,
    currency: 'Comorian Franc ',
    countries: ['Comoros (The)']
  },
  {
    code: 'KPW',
    number: '408',
    digits: 2,
    currency: 'North Korean Won',
    countries: ['Korea (The Democratic People’s Republic Of)']
  },
  {
    code: 'KRW',
    number: '410',
    digits: 0,
    currency: 'Won',
    countries: ['Korea (The Republic Of)']
  },
  {
    code: 'KWD',
    number: '414',
    digits: 3,
    currency: 'Kuwaiti Dinar',
    countries: ['Kuwait']
  },
  {
    code: 'KYD',
    number: '136',
    digits: 2,
    currency: 'Cayman Islands Dollar',
    countries: ['Cayman Islands (The)']
  },
  {
    code: 'KZT',
    number: '398',
    digits: 2,
    currency: 'Tenge',
    countries: ['Kazakhstan']
  },
  {
    code: 'LAK',
    number: '418',
    digits: 2,
    currency: 'Lao Kip',
    countries: ['Lao People’s Democratic Republic (The)']
  },
  {
    code: 'LBP',
    number: '422',
    digits: 2,
    currency: 'Lebanese Pound',
    countries: ['Lebanon']
  },
  {
    code: 'LKR',
    number: '144',
    digits: 2,
    currency: 'Sri Lanka Rupee',
    countries: ['Sri Lanka']
  },
  {
    code: 'LRD',
    number: '430',
    digits: 2,
    currency: 'Liberian Dollar',
    countries: ['Liberia']
  },
  {
    code: 'LSL',
    number: '426',
    digits: 2,
    currency: 'Loti',
    countries: ['Lesotho']
  },
  {
    code: 'LYD',
    number: '434',
    digits: 3,
    currency: 'Libyan Dinar',
    countries: ['Libya']
  },
  {
    code: 'MAD',
    number: '504',
    digits: 2,
    currency: 'Moroccan Dirham',
    countries: ['Morocco', 'Western Sahara']
  },
  {
    code: 'MDL',
    number: '498',
    digits: 2,
    currency: 'Moldovan Leu',
    countries: ['Moldova (The Republic Of)']
  },
  {
    code: 'MGA',
    number: '969',
    digits: 2,
    currency: 'Malagasy Ariary',
    countries: ['Madagascar']
  },
  {
    code: 'MKD',
    number: '807',
    digits: 2,
    currency: 'Denar',
    countries: ['Macedonia (The Former Yugoslav Republic Of)']
  },
  {
    code: 'MMK',
    number: '104',
    digits: 2,
    currency: 'Kyat',
    countries: ['Myanmar']
  },
  {
    code: 'MNT',
    number: '496',
    digits: 2,
    currency: 'Tugrik',
    countries: ['Mongolia']
  },
  {
    code: 'MOP',
    number: '446',
    digits: 2,
    currency: 'Pataca',
    countries: ['Macao']
  },
  {
    code: 'MRU',
    number: '929',
    digits: 2,
    currency: 'Ouguiya',
    countries: ['Mauritania']
  },
  {
    code: 'MUR',
    number: '480',
    digits: 2,
    currency: 'Mauritius Rupee',
    countries: ['Mauritius']
  },
  {
    code: 'MVR',
    number: '462',
    digits: 2,
    currency: 'Rufiyaa',
    countries: ['Maldives']
  },
  {
    code: 'MWK',
    number: '454',
    digits: 2,
    currency: 'Malawi Kwacha',
    countries: ['Malawi']
  },
  {
    code: 'MXN',
    number: '484',
    digits: 2,
    currency: 'Mexican Peso',
    countries: ['Mexico']
  },
  {
    code: 'MXV',
    number: '979',
    digits: 2,
    currency: 'Mexican Unidad de Inversion (UDI)',
    countries: ['Mexico']
  },
  {
    code: 'MYR',
    number: '458',
    digits: 2,
    currency: 'Malaysian Ringgit',
    countries: ['Malaysia']
  },
  {
    code: 'MZN',
    number: '943',
    digits: 2,
    currency: 'Mozambique Metical',
    countries: ['Mozambique']
  },
  {
    code: 'NAD',
    number: '516',
    digits: 2,
    currency: 'Namibia Dollar',
    countries: ['Namibia']
  },
  {
    code: 'NGN',
    number: '566',
    digits: 2,
    currency: 'Naira',
    countries: ['Nigeria']
  },
  {
    code: 'NIO',
    number: '558',
    digits: 2,
    currency: 'Cordoba Oro',
    countries: ['Nicaragua']
  },
  {
    code: 'NOK',
    number: '578',
    digits: 2,
    currency: 'Norwegian Krone',
    countries: ['Bouvet Island', 'Norway', 'Svalbard and Jan Mayen']
  },
  {
    code: 'NPR',
    number: '524',
    digits: 2,
    currency: 'Nepalese Rupee',
    countries: ['Nepal']
  },
  {
    code: 'NZD',
    number: '554',
    digits: 2,
    currency: 'New Zealand Dollar',
    countries: [
      'Cook Islands (The)',
      'New Zealand',
      'Niue',
      'Pitcairn',
      'Tokelau'
    ]
  },
  {
    code: 'OMR',
    number: '512',
    digits: 3,
    currency: 'Rial Omani',
    countries: ['Oman']
  },
  {
    code: 'PAB',
    number: '590',
    digits: 2,
    currency: 'Balboa',
    countries: ['Panama']
  },
  {
    code: 'PEN',
    number: '604',
    digits: 2,
    currency: 'Sol',
    countries: ['Peru']
  },
  {
    code: 'PGK',
    number: '598',
    digits: 2,
    currency: 'Kina',
    countries: ['Papua New Guinea']
  },
  {
    code: 'PHP',
    number: '608',
    digits: 2,
    currency: 'Philippine Peso',
    countries: ['Philippines (The)']
  },
  {
    code: 'PKR',
    number: '586',
    digits: 2,
    currency: 'Pakistan Rupee',
    countries: ['Pakistan']
  },
  {
    code: 'PLN',
    number: '985',
    digits: 2,
    currency: 'Zloty',
    countries: ['Poland']
  },
  {
    code: 'PYG',
    number: '600',
    digits: 0,
    currency: 'Guarani',
    countries: ['Paraguay']
  },
  {
    code: 'QAR',
    number: '634',
    digits: 2,
    currency: 'Qatari Rial',
    countries: ['Qatar']
  },
  {
    code: 'RON',
    number: '946',
    digits: 2,
    currency: 'Romanian Leu',
    countries: ['Romania']
  },
  {
    code: 'RSD',
    number: '941',
    digits: 2,
    currency: 'Serbian Dinar',
    countries: ['Serbia']
  },
  {
    code: 'RUB',
    number: '643',
    digits: 2,
    currency: 'Russian Ruble',
    countries: ['Russian Federation (The)']
  },
  {
    code: 'RWF',
    number: '646',
    digits: 0,
    currency: 'Rwanda Franc',
    countries: ['Rwanda']
  },
  {
    code: 'SAR',
    number: '682',
    digits: 2,
    currency: 'Saudi Riyal',
    countries: ['Saudi Arabia']
  },
  {
    code: 'SBD',
    number: '090',
    digits: 2,
    currency: 'Solomon Islands Dollar',
    countries: ['Solomon Islands']
  },
  {
    code: 'SCR',
    number: '690',
    digits: 2,
    currency: 'Seychelles Rupee',
    countries: ['Seychelles']
  },
  {
    code: 'SDG',
    number: '938',
    digits: 2,
    currency: 'Sudanese Pound',
    countries: ['Sudan (The)']
  },
  {
    code: 'SEK',
    number: '752',
    digits: 2,
    currency: 'Swedish Krona',
    countries: ['Sweden']
  },
  {
    code: 'SGD',
    number: '702',
    digits: 2,
    currency: 'Singapore Dollar',
    countries: ['Singapore']
  },
  {
    code: 'SHP',
    number: '654',
    digits: 2,
    currency: 'Saint Helena Pound',
    countries: ['Saint Helena, Ascension and Tristan Da Cunha']
  },
  {
    code: 'SLL',
    number: '694',
    digits: 2,
    currency: 'Leone',
    countries: ['Sierra Leone']
  },
  {
    code: 'SOS',
    number: '706',
    digits: 2,
    currency: 'Somali Shilling',
    countries: ['Somalia']
  },
  {
    code: 'SRD',
    number: '968',
    digits: 2,
    currency: 'Surinam Dollar',
    countries: ['Suriname']
  },
  {
    code: 'SSP',
    number: '728',
    digits: 2,
    currency: 'South Sudanese Pound',
    countries: ['South Sudan']
  },
  {
    code: 'STN',
    number: '930',
    digits: 2,
    currency: 'Dobra',
    countries: ['Sao Tome and Principe']
  },
  {
    code: 'SVC',
    number: '222',
    digits: 2,
    currency: 'El Salvador Colon',
    countries: ['El Salvador']
  },
  {
    code: 'SYP',
    number: '760',
    digits: 2,
    currency: 'Syrian Pound',
    countries: ['Syrian Arab Republic']
  },
  {
    code: 'SZL',
    number: '748',
    digits: 2,
    currency: 'Lilangeni',
    countries: ['Eswatini']
  },
  {
    code: 'THB',
    number: '764',
    digits: 2,
    currency: 'Baht',
    countries: ['Thailand']
  },
  {
    code: 'TJS',
    number: '972',
    digits: 2,
    currency: 'Somoni',
    countries: ['Tajikistan']
  },
  {
    code: 'TMT',
    number: '934',
    digits: 2,
    currency: 'Turkmenistan New Manat',
    countries: ['Turkmenistan']
  },
  {
    code: 'TND',
    number: '788',
    digits: 3,
    currency: 'Tunisian Dinar',
    countries: ['Tunisia']
  },
  {
    code: 'TOP',
    number: '776',
    digits: 2,
    currency: 'Pa’anga',
    countries: ['Tonga']
  },
  {
    code: 'TRY',
    number: '949',
    digits: 2,
    currency: 'Turkish Lira',
    countries: ['Turkey']
  },
  {
    code: 'TTD',
    number: '780',
    digits: 2,
    currency: 'Trinidad and Tobago Dollar',
    countries: ['Trinidad and Tobago']
  },
  {
    code: 'TWD',
    number: '901',
    digits: 2,
    currency: 'New Taiwan Dollar',
    countries: ['Taiwan (Province of China)']
  },
  {
    code: 'TZS',
    number: '834',
    digits: 2,
    currency: 'Tanzanian Shilling',
    countries: ['Tanzania, United Republic Of']
  },
  {
    code: 'UAH',
    number: '980',
    digits: 2,
    currency: 'Hryvnia',
    countries: ['Ukraine']
  },
  {
    code: 'UGX',
    number: '800',
    digits: 0,
    currency: 'Uganda Shilling',
    countries: ['Uganda']
  },
  {
    code: 'USD',
    number: '840',
    digits: 2,
    currency: 'US Dollar',
    countries: [
      'American Samoa',
      'Bonaire, Sint Eustatius and Saba',
      'British Indian Ocean Territory (The)',
      'Ecuador',
      'El Salvador',
      'Guam',
      'Haiti',
      'Marshall Islands (The)',
      'Micronesia (Federated States Of)',
      'Northern Mariana Islands (The)',
      'Palau',
      'Panama',
      'Puerto Rico',
      'Timor-Leste',
      'Turks and Caicos Islands (The)',
      'United States Minor Outlying Islands (The)',
      'United States of America (The)',
      'Virgin Islands (British)',
      'Virgin Islands (U.S.)'
    ]
  },
  {
    code: 'USN',
    number: '997',
    digits: 2,
    currency: 'US Dollar (Next day)',
    countries: ['United States of America (The)']
  },
  {
    code: 'UYI',
    number: '940',
    digits: 0,
    currency: 'Uruguay Peso en Unidades Indexadas (UI)',
    countries: ['Uruguay']
  },
  {
    code: 'UYU',
    number: '858',
    digits: 2,
    currency: 'Peso Uruguayo',
    countries: ['Uruguay']
  },
  {
    code: 'UYW',
    number: '927',
    digits: 4,
    currency: 'Unidad Previsional',
    countries: ['Uruguay']
  },
  {
    code: 'UZS',
    number: '860',
    digits: 2,
    currency: 'Uzbekistan Sum',
    countries: ['Uzbekistan']
  },
  {
    code: 'VES',
    number: '928',
    digits: 2,
    currency: 'Bolívar Soberano',
    countries: ['Venezuela (Bolivarian Republic Of)']
  },
  {
    code: 'VND',
    number: '704',
    digits: 0,
    currency: 'Dong',
    countries: ['Viet Nam']
  },
  {
    code: 'VUV',
    number: '548',
    digits: 0,
    currency: 'Vatu',
    countries: ['Vanuatu']
  },
  {
    code: 'WST',
    number: '882',
    digits: 2,
    currency: 'Tala',
    countries: ['Samoa']
  },
  {
    code: 'XAF',
    number: '950',
    digits: 0,
    currency: 'CFA Franc BEAC',
    countries: [
      'Cameroon',
      'Central African Republic (The)',
      'Chad',
      'Congo (The)',
      'Equatorial Guinea',
      'Gabon'
    ]
  },
  {
    code: 'XAG',
    number: '961',
    digits: 0,
    currency: 'Silver',
    countries: ['Zz11_silver']
  },
  {
    code: 'XAU',
    number: '959',
    digits: 0,
    currency: 'Gold',
    countries: ['Zz08_gold']
  },
  {
    code: 'XBA',
    number: '955',
    digits: 0,
    currency: 'Bond Markets Unit European Composite Unit (EURCO)',
    countries: ['Zz01_bond Markets Unit European_eurco']
  },
  {
    code: 'XBB',
    number: '956',
    digits: 0,
    currency: 'Bond Markets Unit European Monetary Unit (E.M.U.-6)',
    countries: ['Zz02_bond Markets Unit European_emu-6']
  },
  {
    code: 'XBC',
    number: '957',
    digits: 0,
    currency: 'Bond Markets Unit European Unit of Account 9 (E.U.A.-9)',
    countries: ['Zz03_bond Markets Unit European_eua-9']
  },
  {
    code: 'XBD',
    number: '958',
    digits: 0,
    currency: 'Bond Markets Unit European Unit of Account 17 (E.U.A.-17)',
    countries: ['Zz04_bond Markets Unit European_eua-17']
  },
  {
    code: 'XCD',
    number: '951',
    digits: 2,
    currency: 'East Caribbean Dollar',
    countries: [
      'Anguilla',
      'Antigua and Barbuda',
      'Dominica',
      'Grenada',
      'Montserrat',
      'Saint Kitts and Nevis',
      'Saint Lucia',
      'Saint Vincent and the Grenadines'
    ]
  },
  {
    code: 'XDR',
    number: '960',
    digits: 0,
    currency: 'SDR (Special Drawing Right)',
    countries: ['International Monetary Fund (Imf) ']
  },
  {
    code: 'XOF',
    number: '952',
    digits: 0,
    currency: 'FCFA',
    countries: [
      'Benin',
      'Burkina Faso',
      "Côte d'Ivoire",
      'Guinea-Bissau',
      'Mali',
      'Niger (The)',
      'Senegal',
      'Togo'
    ]
  },
  {
    code: 'XPD',
    number: '964',
    digits: 0,
    currency: 'Palladium',
    countries: ['Zz09_palladium']
  },
  {
    code: 'XPF',
    number: '953',
    digits: 0,
    currency: 'CFP Franc',
    countries: ['French Polynesia', 'New Caledonia', 'Wallis and Futuna']
  },
  {
    code: 'XPT',
    number: '962',
    digits: 0,
    currency: 'Platinum',
    countries: ['Zz10_platinum']
  },
  {
    code: 'XSU',
    number: '994',
    digits: 0,
    currency: 'Sucre',
    countries: ['Sistema Unitario De Compensacion Regional De Pagos "Sucre"']
  },
  {
    code: 'XTS',
    number: '963',
    digits: 0,
    currency: 'Codes specifically reserved for testing purposes',
    countries: ['Zz06_testing_code']
  },
  {
    code: 'XUA',
    number: '965',
    digits: 0,
    currency: 'ADB Unit of Account',
    countries: ['Member Countries of the African Development Bank Group']
  },
  {
    code: 'XXX',
    number: '999',
    digits: 0,
    currency:
      'The codes assigned for transactions where no currency is involved',
    countries: ['Zz07_no_currency']
  },
  {
    code: 'YER',
    number: '886',
    digits: 2,
    currency: 'Yemeni Rial',
    countries: ['Yemen']
  },
  {
    code: 'ZAR',
    number: '710',
    digits: 2,
    currency: 'Rand',
    countries: ['Lesotho', 'Namibia', 'South Africa']
  },
  {
    code: 'ZMW',
    number: '967',
    digits: 2,
    currency: 'Zambian Kwacha',
    countries: ['Zambia']
  },
  {
    code: 'ZWL',
    number: '932',
    digits: 2,
    currency: 'Zimbabwe Dollar',
    countries: ['Zimbabwe']
  }
];

// Actual ref
// https://github.com/freeall/currency-codes/blob/master/data.js
// other useful Ref
// https://gist.github.com/Fluidbyte/2973986
// https://gist.github.com/simibac/db4ad8da20d4173a0f2d7fb4967a3e9f

export const CURRENCY_SYMBOL_MAP = {
  AED: 'د.إ',
  AFN: '؋',
  ALL: 'L',
  AMD: '֏',
  ANG: 'ƒ',
  AOA: 'Kz',
  ARS: '$',
  AUD: '$',
  AWG: 'ƒ',
  AZN: '₼',
  BAM: 'KM',
  BBD: '$',
  BDT: '৳',
  BGN: 'лв',
  BHD: '.د.ب',
  BIF: 'FBu',
  BMD: '$',
  BND: '$',
  BOB: '$b',
  BOV: 'BOV',
  BRL: 'R$',
  BSD: '$',
  BTC: '₿',
  BTN: 'Nu.',
  BWP: 'P',
  BYN: 'Br',
  BYR: 'Br',
  BZD: 'BZ$',
  CAD: '$',
  CDF: 'FC',
  CHE: 'CHE',
  CHF: 'CHF',
  CHW: 'CHW',
  CLF: 'CLF',
  CLP: '$',
  CNY: '¥',
  COP: '$',
  COU: 'COU',
  CRC: '₡',
  CUC: '$',
  CUP: '₱',
  CVE: '$',
  CZK: 'Kč',
  DJF: 'Fdj',
  DKK: 'kr',
  DOP: 'RD$',
  DZD: 'دج',
  EEK: 'kr',
  EGP: '£',
  ERN: 'Nfk',
  ETB: 'Br',
  ETH: 'Ξ',
  EUR: '€',
  FJD: '$',
  FKP: '£',
  GBP: '£',
  GEL: '₾',
  GGP: '£',
  GHC: '₵',
  GHS: 'GH₵',
  GIP: '£',
  GMD: 'D',
  GNF: 'FG',
  GTQ: 'Q',
  GYD: '$',
  HKD: '$',
  HNL: 'L',
  HRK: 'kn',
  HTG: 'G',
  HUF: 'Ft',
  IDR: 'Rp',
  ILS: '₪',
  IMP: '£',
  INR: '₹',
  IQD: 'ع.د',
  IRR: '﷼',
  ISK: 'kr',
  JEP: '£',
  JMD: 'J$',
  JOD: 'JD',
  JPY: '¥',
  KES: 'KSh',
  KGS: 'лв',
  KHR: '៛',
  KMF: 'CF',
  KPW: '₩',
  KRW: '₩',
  KWD: 'KD',
  KYD: '$',
  KZT: '₸',
  LAK: '₭',
  LBP: '£',
  LKR: '₨',
  LRD: '$',
  LSL: 'M',
  LTC: 'Ł',
  LTL: 'Lt',
  LVL: 'Ls',
  LYD: 'LD',
  MAD: 'MAD',
  MDL: 'lei',
  MGA: 'Ar',
  MKD: 'ден',
  MMK: 'K',
  MNT: '₮',
  MOP: 'MOP$',
  MRO: 'UM',
  MRU: 'UM',
  MUR: '₨',
  MVR: 'Rf',
  MWK: 'MK',
  MXN: '$',
  MXV: 'MXV',
  MYR: 'RM',
  MZN: 'MT',
  NAD: '$',
  NGN: '₦',
  NIO: 'C$',
  NOK: 'kr',
  NPR: '₨',
  NZD: '$',
  OMR: '﷼',
  PAB: 'B/.',
  PEN: 'S/.',
  PGK: 'K',
  PHP: '₱',
  PKR: '₨',
  PLN: 'zł',
  PYG: 'Gs',
  QAR: '﷼',
  RMB: '￥',
  RON: 'lei',
  RSD: 'Дин.',
  RUB: '₽',
  RWF: 'R₣',
  SAR: '﷼',
  SBD: '$',
  SCR: '₨',
  SDG: 'ج.س.',
  SEK: 'kr',
  SGD: 'S$',
  SHP: '£',
  SLL: 'Le',
  SOS: 'S',
  SRD: '$',
  SSP: '£',
  STD: 'Db',
  STN: 'Db',
  SVC: '$',
  SYP: '£',
  SZL: 'E',
  THB: '฿',
  TJS: 'SM',
  TMT: 'T',
  TND: 'د.ت',
  TOP: 'T$',
  TRL: '₤',
  TRY: '₺',
  TTD: 'TT$',
  TVD: '$',
  TWD: 'NT$',
  TZS: 'TSh',
  UAH: '₴',
  UGX: 'USh',
  USD: '$',
  UYI: 'UYI',
  UYU: '$U',
  UYW: 'UYW',
  UZS: 'лв',
  VEF: 'Bs',
  VES: 'Bs.S',
  VND: '₫',
  VUV: 'VT',
  WST: 'WS$',
  XAF: 'FCFA',
  XBT: 'Ƀ',
  XCD: '$',
  XOF: 'CFA',
  XPF: '₣',
  XSU: 'Sucre',
  XUA: 'XUA',
  YER: '﷼',
  ZAR: 'R',
  ZMW: 'ZK',
  ZWD: 'Z$',
  ZWL: '$'
};

export const CURRENCY_LIST = ALL_CURRENCY_LIST.filter((curr) =>
  SUPPORTED_CURRENCIES.includes(curr.code)
).sort((a, b) => {
  if (a.currency < b.currency) {
    return -1;
  }
  if (a.currency > b.currency) {
    return 1;
  }
  return 0;
});

const locales = [
  {
    alpha2: 'AS',
    alpha3: 'ASM',
    currency: 'USD',
    currency_name: 'US Dollar',
    default_locale: 'en-AS',
    locales: ['en-AS'],
    name: 'American Samoa'
  },
  {
    alpha2: 'AD',
    alpha3: 'AND',
    currency: 'EUR',
    currency_name: 'Euro',
    default_locale: 'ca',
    locales: ['ca'],
    name: 'Andorra'
  },
  {
    alpha2: 'AQ',
    alpha3: 'ATA',
    currency: 'USD',
    currency_name: 'US Dollar',
    default_locale: 'en-US',
    locales: ['en-US'],
    name: 'Antarctica'
  },
  {
    alpha2: 'AR',
    alpha3: 'ARG',
    currency: 'ARS',
    currency_name: 'Argentine Peso',
    default_locale: 'es-AR',
    locales: ['es-AR'],
    name: 'Argentina'
  },
  {
    alpha2: 'AU',
    alpha3: 'AUS',
    currency: 'AUD',
    currency_name: 'Australian Dollar',
    default_locale: 'en-AU',
    locales: ['en-AU'],
    name: 'Australia'
  },
  {
    alpha2: 'AT',
    alpha3: 'AUT',
    currency: 'EUR',
    currency_name: 'Euro',
    default_locale: 'de-AT',
    locales: ['de-AT'],
    name: 'Austria'
  },
  {
    alpha2: 'BH',
    alpha3: 'BHR',
    currency: 'BHD',
    currency_name: 'Bahraini Dinar',
    default_locale: 'ar-BH',
    locales: ['ar-BH'],
    name: 'Bahrain'
  },
  {
    alpha2: 'BE',
    alpha3: 'BEL',
    currency: 'EUR',
    currency_name: 'Euro',
    default_locale: 'nl-BE',
    locales: ['nl-BE', 'en-BE', 'fr-BE', 'de-BE'],
    name: 'Belgium'
  },
  {
    alpha2: 'BQ',
    alpha3: 'BES',
    currency: 'USD',
    currency_name: 'US Dollar',
    default_locale: 'nl',
    locales: ['nl'],
    name: 'Bonaire'
  },
  {
    alpha2: 'BV',
    alpha3: 'BVT',
    currency: 'NOK',
    currency_name: 'Norwegian Krone',
    default_locale: 'no',
    locales: ['no'],
    name: 'Bouvet Island'
  },
  {
    alpha2: 'BR',
    alpha3: 'BRA',
    currency: 'BRL',
    currency_name: 'Brazilian Real',
    default_locale: 'pt-BR',
    locales: ['pt-BR'],
    name: 'Brazil'
  },
  {
    alpha2: 'IO',
    alpha3: 'IOT',
    currency: 'USD',
    currency_name: 'US Dollar',
    default_locale: 'en',
    locales: ['en'],
    name: 'British Indian Ocean Territory'
  },
  {
    alpha2: 'CA',
    alpha3: 'CAN',
    currency: 'CAD',
    currency_name: 'Canadian Dollar',
    default_locale: 'en-CA',
    locales: ['en-CA', 'fr-CA'],
    name: 'Canada'
  },
  {
    alpha2: 'CN',
    alpha3: 'CHN',
    currency: 'CNY',
    currency_name: 'Yuan Renminbi',
    default_locale: 'zh-CN',
    locales: ['zh-CN', 'zh-Hans-CN', 'ii-CN', 'bo-CN'],
    name: 'China'
  },
  {
    alpha2: 'CX',
    alpha3: 'CXR',
    currency: 'AUD',
    currency_name: 'Australian Dollar',
    default_locale: 'en',
    locales: ['en'],
    name: 'Christmas Island'
  },
  {
    alpha2: 'CC',
    alpha3: 'CCK',
    currency: 'AUD',
    currency_name: 'Australian Dollar',
    default_locale: 'en',
    locales: ['en'],
    name: 'Cocos Islands'
  },
  {
    alpha2: 'CK',
    alpha3: 'COK',
    currency: 'NZD',
    currency_name: 'New Zealand Dollar',
    default_locale: 'en',
    locales: ['en'],
    name: 'Cook Islands'
  },
  {
    alpha2: 'CY',
    alpha3: 'CYP',
    currency: 'EUR',
    currency_name: 'Euro',
    default_locale: 'el-CY',
    locales: ['el-CY'],
    name: 'Cyprus'
  },
  {
    alpha2: 'DK',
    alpha3: 'DNK',
    currency: 'DKK',
    currency_name: 'Danish Krone',
    default_locale: 'da-DK',
    locales: ['da-DK'],
    name: 'Denmark'
  },
  {
    alpha2: 'EC',
    alpha3: 'ECU',
    currency: 'USD',
    currency_name: 'US Dollar',
    default_locale: 'es-EC',
    locales: ['es-EC'],
    name: 'Ecuador'
  },
  {
    alpha2: 'SV',
    alpha3: 'SLV',
    currency: 'USD',
    currency_name: 'US Dollar',
    default_locale: 'es-SV',
    locales: ['es-SV'],
    name: 'El Salvador'
  },
  {
    alpha2: 'EE',
    alpha3: 'EST',
    currency: 'EUR',
    currency_name: 'Euro',
    default_locale: 'et-EE',
    locales: ['et-EE'],
    name: 'Estonia'
  },
  {
    alpha2: 'SZ',
    alpha3: 'SWZ',
    currency: 'EUR',
    currency_name: 'Euro',
    default_locale: 'en',
    locales: ['en'],
    name: 'Eswatini'
  },
  {
    alpha2: 'FK',
    alpha3: 'FLK',
    currency: 'DKK',
    currency_name: 'Danish Krone',
    default_locale: 'en',
    locales: ['en'],
    name: 'Falkland Islands'
  },
  {
    alpha2: 'FO',
    alpha3: 'FRO',
    currency: 'DKK',
    currency_name: 'Danish Krone',
    default_locale: 'fo-FO',
    locales: ['fo-FO'],
    name: 'Faroe Islands'
  },
  {
    alpha2: 'FI',
    alpha3: 'FIN',
    currency: 'EUR',
    currency_name: 'Euro',
    default_locale: 'fi-FI',
    locales: ['fi-FI', 'sv-FI'],
    name: 'Finland'
  },
  {
    alpha2: 'FR',
    alpha3: 'FRA',
    currency: 'EUR',
    currency_name: 'Euro',
    default_locale: 'fr-FR',
    locales: ['fr-FR'],
    name: 'France'
  },
  {
    alpha2: 'GF',
    alpha3: 'GUF',
    currency: 'EUR',
    currency_name: 'Euro',
    default_locale: 'fr',
    locales: ['fr'],
    name: 'French Guiana'
  },
  {
    alpha2: 'TF',
    alpha3: 'ATF',
    currency: 'EUR',
    currency_name: 'Euro',
    default_locale: 'fr',
    locales: ['fr'],
    name: 'French Southern Territories'
  },
  {
    alpha2: 'DE',
    alpha3: 'DEU',
    currency: 'EUR',
    currency_name: 'Euro',
    default_locale: 'de-DE',
    locales: ['de-DE'],
    name: 'Germany'
  },
  {
    alpha2: 'GR',
    alpha3: 'GRC',
    currency: 'EUR',
    currency_name: 'Euro',
    default_locale: 'el-GR',
    locales: ['el-GR'],
    name: 'Greece'
  },
  {
    alpha2: 'GL',
    alpha3: 'GRL',
    currency: 'DKK',
    currency_name: 'Danish Krone',
    default_locale: 'kl-GL',
    locales: ['kl-GL'],
    name: 'Greenland'
  },
  {
    alpha2: 'GP',
    alpha3: 'GLP',
    currency: 'EUR',
    currency_name: 'Euro',
    default_locale: 'fr-GP',
    locales: ['fr-GP'],
    name: 'Guadeloupe'
  },
  {
    alpha2: 'GU',
    alpha3: 'GUM',
    currency: 'USD',
    currency_name: 'US Dollar',
    default_locale: 'en-GU',
    locales: ['en-GU'],
    name: 'Guam'
  },
  {
    alpha2: 'GG',
    alpha3: 'GGY',
    currency: 'GBP',
    currency_name: 'Pound Sterling',
    default_locale: 'en',
    locales: ['en'],
    name: 'Guernsey'
  },
  {
    alpha2: 'HT',
    alpha3: 'HTI',
    currency: 'USD',
    currency_name: 'US Dollar',
    default_locale: 'fr',
    locales: ['fr'],
    name: 'Haiti'
  },
  {
    alpha2: 'HM',
    alpha3: 'HMD',
    currency: 'AUD',
    currency_name: 'Australian Dollar',
    default_locale: 'en',
    locales: ['en'],
    name: 'Heard Island and McDonald Islands'
  },
  {
    alpha2: 'VA',
    alpha3: 'VAT',
    currency: 'EUR',
    currency_name: 'Euro',
    default_locale: 'it',
    locales: ['it'],
    name: 'Holy See'
  },
  {
    alpha2: 'IS',
    alpha3: 'ISL',
    currency: 'ISK',
    currency_name: 'Iceland Krona',
    default_locale: 'is-IS',
    locales: ['is-IS'],
    name: 'Iceland'
  },
  {
    alpha2: 'IN',
    alpha3: 'IND',
    currency: 'INR',
    currency_name: 'Indian Rupee',
    default_locale: 'hi-IN',
    locales: [
      'as-IN',
      'bn-IN',
      'en-IN',
      'gu-IN',
      'hi-IN',
      'kn-IN',
      'kok-IN',
      'ml-IN',
      'mr-IN',
      'ne-IN',
      'or-IN',
      'pa-Guru-IN',
      'ta-IN',
      'te-IN',
      'bo-IN',
      'ur-IN'
    ],
    name: 'India'
  },
  {
    alpha2: 'ID',
    alpha3: 'IDN',
    currency: 'IDR',
    currency_name: 'Rupiah',
    default_locale: 'id-ID',
    locales: ['id-ID'],
    name: 'Indonesia'
  },
  {
    alpha2: 'IE',
    alpha3: 'IRL',
    currency: 'EUR',
    currency_name: 'Euro',
    default_locale: 'en-IE',
    locales: ['en-IE', 'ga-IE'],
    name: 'Ireland'
  },
  {
    alpha2: 'IM',
    alpha3: 'IMN',
    currency: 'GBP',
    currency_name: 'Pound Sterling',
    default_locale: 'en',
    locales: ['en'],
    name: 'Isle of Man'
  },
  {
    alpha2: 'IT',
    alpha3: 'ITA',
    currency: 'EUR',
    currency_name: 'Euro',
    default_locale: 'it-IT',
    locales: ['it-IT'],
    name: 'Italy'
  },
  {
    alpha2: 'JP',
    alpha3: 'JPN',
    currency: 'JPY',
    currency_name: 'Yen',
    default_locale: 'ja-JP',
    locales: ['ja-JP'],
    name: 'Japan'
  },
  {
    alpha2: 'JE',
    alpha3: 'JEY',
    currency: 'GBP',
    currency_name: 'Pound Sterling',
    default_locale: 'en',
    locales: ['en'],
    name: 'Jersey'
  },
  {
    alpha2: 'KE',
    alpha3: 'KEN',
    currency: 'KES',
    currency_name: 'Kenyan Shilling',
    default_locale: 'ebu-KE',
    locales: [
      'ebu-KE',
      'guz-KE',
      'kln-KE',
      'kam-KE',
      'ki-KE',
      'luo-KE',
      'luy-KE',
      'mas-KE',
      'mer-KE',
      'om-KE',
      'saq-KE',
      'so-KE',
      'sw-KE',
      'dav-KE',
      'teo-KE'
    ],
    name: 'Kenya'
  },
  {
    alpha2: 'KI',
    alpha3: 'KIR',
    currency: 'AUD',
    currency_name: 'Australian Dollar',
    default_locale: 'en',
    locales: ['en'],
    name: 'Kiribati'
  },
  {
    alpha2: 'KR',
    alpha3: 'KOR',
    currency: 'KRW',
    currency_name: 'South Korean Won',
    default_locale: 'ko-KR',
    locales: ['ko-KR'],
    name: 'South Korea'
  },
  {
    alpha2: 'LV',
    alpha3: 'LVA',
    currency: 'EUR',
    currency_name: 'Euro',
    default_locale: 'lv-LV',
    locales: ['lv-LV'],
    name: 'Latvia'
  },
  {
    alpha2: 'LS',
    alpha3: 'LSO',
    currency: 'ZAR',
    currency_name: 'Rand',
    default_locale: 'en',
    locales: ['en'],
    name: 'Lesotho'
  },
  {
    alpha2: 'LI',
    alpha3: 'LIE',
    currency: 'CHF',
    currency_name: 'Swiss Franc',
    default_locale: 'de-LI',
    locales: ['de-LI'],
    name: 'Liechtenstein'
  },
  {
    alpha2: 'LT',
    alpha3: 'LTU',
    currency: 'EUR',
    currency_name: 'Euro',
    default_locale: 'lt-LT',
    locales: ['lt-LT'],
    name: 'Lithuania'
  },
  {
    alpha2: 'LU',
    alpha3: 'LUX',
    currency: 'EUR',
    currency_name: 'Euro',
    default_locale: 'fr-LU',
    locales: ['fr-LU', 'de-LU'],
    name: 'Luxembourg'
  },
  {
    alpha2: 'MT',
    alpha3: 'MLT',
    currency: 'EUR',
    currency_name: 'Euro',
    default_locale: 'en-MT',
    locales: ['en-MT', 'mt-MT'],
    name: 'Malta'
  },
  {
    alpha2: 'MH',
    alpha3: 'MHL',
    currency: 'USD',
    currency_name: 'US Dollar',
    default_locale: 'en-MH',
    locales: ['en-MH'],
    name: 'Marshall Islands'
  },
  {
    alpha2: 'MQ',
    alpha3: 'MTQ',
    currency: 'EUR',
    currency_name: 'Euro',
    default_locale: 'fr-MQ',
    locales: ['fr-MQ'],
    name: 'Martinique'
  },
  {
    alpha2: 'YT',
    alpha3: 'MYT',
    currency: 'EUR',
    currency_name: 'Euro',
    default_locale: 'fr',
    locales: ['fr'],
    name: 'Mayotte'
  },
  {
    alpha2: 'FM',
    alpha3: 'FSM',
    currency: 'RUB',
    currency_name: 'Russian Ruble',
    default_locale: 'en',
    locales: ['en'],
    name: 'Micronesia'
  },
  {
    alpha2: 'MC',
    alpha3: 'MCO',
    currency: 'EUR',
    currency_name: 'Euro',
    default_locale: 'fr-MC',
    locales: ['fr-MC'],
    name: 'Monaco'
  },
  {
    alpha2: 'ME',
    alpha3: 'MNE',
    currency: 'EUR',
    currency_name: 'Euro',
    default_locale: 'sr-Cyrl-ME',
    locales: ['sr-Cyrl-ME', 'sr-Latn-ME'],
    name: 'Montenegro'
  },
  {
    alpha2: 'NA',
    alpha3: 'NAM',
    currency: 'ZAR',
    currency_name: 'Rand',
    default_locale: 'en-NA',
    locales: ['af-NA', 'en-NA', 'naq-NA'],
    name: 'Namibia'
  },
  {
    alpha2: 'NR',
    alpha3: 'NRU',
    currency: 'AUD',
    currency_name: 'Australian Dollar',
    default_locale: 'en',
    locales: ['en'],
    name: 'Nauru'
  },
  {
    alpha2: 'NL',
    alpha3: 'NLD',
    currency: 'EUR',
    currency_name: 'Euro',
    default_locale: 'nl-NL',
    locales: ['nl-NL'],
    name: 'Netherlands'
  },
  {
    alpha2: 'NZ',
    alpha3: 'NZL',
    currency: 'NZD',
    currency_name: 'New Zealand Dollar',
    default_locale: 'en-NZ',
    locales: ['en-NZ'],
    name: 'New Zealand'
  },
  {
    alpha2: 'NU',
    alpha3: 'NIU',
    currency: 'NZD',
    currency_name: 'New Zealand Dollar',
    default_locale: 'en',
    locales: ['en'],
    name: 'Niue'
  },
  {
    alpha2: 'NF',
    alpha3: 'NFK',
    currency: 'AUD',
    currency_name: 'Australian Dollar',
    default_locale: 'en',
    locales: ['en'],
    name: 'Norfolk Island'
  },
  {
    alpha2: 'MK',
    alpha3: 'MKD',
    currency: 'AUD',
    currency_name: 'Australian Dollar',
    default_locale: 'mk-MK',
    locales: ['mk-MK'],
    name: 'North Macedonia'
  },
  {
    alpha2: 'MP',
    alpha3: 'MNP',
    currency: 'USD',
    currency_name: 'US Dollar',
    default_locale: 'en-MP',
    locales: ['en-MP'],
    name: 'Northern Mariana Islands'
  },
  {
    alpha2: 'NO',
    alpha3: 'NOR',
    currency: 'NOK',
    currency_name: 'Norwegian Krone',
    default_locale: 'nb-NO',
    locales: ['nb-NO', 'nn-NO'],
    name: 'Norway'
  },
  {
    alpha2: 'PW',
    alpha3: 'PLW',
    currency: 'USD',
    currency_name: 'US Dollar',
    default_locale: 'en',
    locales: ['en'],
    name: 'Palau'
  },
  {
    alpha2: 'PS',
    alpha3: 'PSE',
    currency: 'USD',
    currency_name: 'US Dollar',
    default_locale: 'ar',
    locales: ['ar'],
    name: 'Palestine'
  },
  {
    alpha2: 'PA',
    alpha3: 'PAN',
    currency: 'USD',
    currency_name: 'US Dollar',
    default_locale: 'es-PA',
    locales: ['es-PA'],
    name: 'Panama'
  },
  {
    alpha2: 'PN',
    alpha3: 'PCN',
    currency: 'NZD',
    currency_name: 'New Zealand Dollar',
    default_locale: 'en',
    locales: ['en'],
    name: 'Pitcairn'
  },
  {
    alpha2: 'PT',
    alpha3: 'PRT',
    currency: 'EUR',
    currency_name: 'Euro',
    default_locale: 'pt-PT',
    locales: ['pt-PT'],
    name: 'Portugal'
  },
  {
    alpha2: 'PR',
    alpha3: 'PRI',
    currency: 'USD',
    currency_name: 'US Dollar',
    default_locale: 'es-PR',
    locales: ['es-PR'],
    name: 'Puerto Rico'
  },
  {
    alpha2: 'QA',
    alpha3: 'QAT',
    currency: 'QAR',
    currency_name: 'Qatari Rial',
    default_locale: 'ar-QA',
    locales: ['ar-QA'],
    name: 'Qatar'
  },
  {
    alpha2: 'RU',
    alpha3: 'RUS',
    currency: 'RUB',
    currency_name: 'Russian Ruble',
    default_locale: 'ru-RU',
    locales: ['ru-RU'],
    name: 'Russia'
  },
  {
    alpha2: 'BL',
    alpha3: 'BLM',
    currency: 'EUR',
    currency_name: 'Euro',
    default_locale: 'fr-BL',
    locales: ['fr-BL'],
    name: 'Saint Barthélemy'
  },
  {
    alpha2: 'MF',
    alpha3: 'MAF',
    currency: 'EUR',
    currency_name: 'Euro',
    default_locale: 'fr-MF',
    locales: ['fr-MF'],
    name: 'Saint Martin'
  },
  {
    alpha2: 'PM',
    alpha3: 'SPM',
    currency: 'EUR',
    currency_name: 'Euro',
    default_locale: 'fr',
    locales: ['fr'],
    name: 'Saint Pierre and Miquelon'
  },
  {
    alpha2: 'SM',
    alpha3: 'SMR',
    currency: 'EUR',
    currency_name: 'Euro',
    default_locale: 'it',
    locales: ['it'],
    name: 'San Marino'
  },
  {
    alpha2: 'SA',
    alpha3: 'SAU',
    currency: 'SAR',
    currency_name: 'Saudi Riyal',
    default_locale: 'ar-SA',
    locales: ['ar-SA'],
    name: 'Saudi Arabia'
  },
  {
    alpha2: 'SG',
    alpha3: 'SGP',
    currency: 'SGD',
    currency_name: 'Singapore Dollar',
    default_locale: 'en-SG',
    locales: ['zh-Hans-SG', 'en-SG'],
    name: 'Singapore'
  },
  {
    alpha2: 'SK',
    alpha3: 'SVK',
    currency: 'EUR',
    currency_name: 'Euro',
    default_locale: 'sk-SK',
    locales: ['sk-SK'],
    name: 'Slovakia'
  },
  {
    alpha2: 'SI',
    alpha3: 'SVN',
    currency: 'EUR',
    currency_name: 'Euro',
    default_locale: 'sl-SI',
    locales: ['sl-SI'],
    name: 'Slovenia'
  },
  {
    alpha2: 'ZA',
    alpha3: 'ZAF',
    currency: 'ZAR',
    currency_name: 'Rand',
    default_locale: 'af-ZA',
    locales: ['af-ZA', 'en-ZA', 'zu-ZA'],
    name: 'South Africa'
  },
  {
    alpha2: 'GS',
    alpha3: 'SGS',
    currency: 'USD',
    currency_name: 'US Dollar',
    default_locale: 'en',
    locales: ['en'],
    name: 'South Georgia and the South Sandwich Islands'
  },
  {
    alpha2: 'ES',
    alpha3: 'ESP',
    currency: 'EUR',
    currency_name: 'Euro',
    default_locale: 'es-ES',
    locales: ['eu-ES', 'ca-ES', 'gl-ES', 'es-ES'],
    name: 'Spain'
  },
  {
    alpha2: 'SJ',
    alpha3: 'SJM',
    currency: 'NOK',
    currency_name: 'Norwegian Krone',
    default_locale: 'no',
    locales: ['no'],
    name: 'Svalbard and Jan Mayen'
  },
  {
    alpha2: 'SE',
    alpha3: 'SWE',
    currency: 'SEK',
    currency_name: 'Swedish Krona',
    default_locale: 'sv-SE',
    locales: ['sv-SE'],
    name: 'Sweden'
  },
  {
    alpha2: 'TL',
    alpha3: 'TLS',
    currency: 'USD',
    currency_name: 'US Dollar',
    default_locale: 'pt',
    locales: ['pt'],
    name: 'Timor-Leste'
  },
  {
    alpha2: 'TK',
    alpha3: 'TKL',
    currency: 'NZD',
    currency_name: 'New Zealand Dollar',
    default_locale: 'en',
    locales: ['en'],
    name: 'Tokelau'
  },
  {
    alpha2: 'TR',
    alpha3: 'TUR',
    currency: 'TRY',
    currency_name: 'Turkish Lira',
    default_locale: 'tr-TR',
    locales: ['tr-TR'],
    name: 'Turkey'
  },
  {
    alpha2: 'TC',
    alpha3: 'TCA',
    currency: 'USD',
    currency_name: 'US Dollar',
    default_locale: 'en',
    locales: ['en'],
    name: 'Turks and Caicos Islands'
  },
  {
    alpha2: 'TV',
    alpha3: 'TUV',
    currency: 'AUD',
    currency_name: 'Australian Dollar',
    default_locale: 'en',
    locales: ['en'],
    name: 'Tuvalu'
  },
  {
    alpha2: 'AE',
    alpha3: 'ARE',
    currency: 'AED',
    currency_name: 'UAE Dirham',
    default_locale: 'ar-AE',
    locales: ['ar-AE'],
    name: 'United Arab Emirates'
  },
  {
    alpha2: 'GB',
    alpha3: 'GBR',
    currency: 'GBP',
    currency_name: 'Pound Sterling',
    default_locale: 'en-GB',
    locales: ['kw-GB', 'en-GB', 'gv-GB', 'cy-GB'],
    name: 'United Kingdom'
  },
  {
    alpha2: 'UM',
    alpha3: 'UMI',
    currency: 'USD',
    currency_name: 'US Dollar',
    default_locale: 'en-UM',
    locales: ['en-UM'],
    name: 'United States Minor Outlying Islands'
  },
  {
    alpha2: 'US',
    alpha3: 'USA',
    currency: 'USD',
    currency_name: 'US Dollar',
    default_locale: 'en-US',
    locales: ['chr-US', 'en-US', 'haw-US', 'es-US'],
    name: 'United States'
  },
  {
    alpha2: 'VG',
    alpha3: 'VGB',
    currency: 'USD',
    currency_name: 'US Dollar',
    default_locale: 'en',
    locales: ['en'],
    name: 'Virgin Islands (British)'
  },
  {
    alpha2: 'VI',
    alpha3: 'VIR',
    currency: 'USD',
    currency_name: 'US Dollar',
    default_locale: 'en-VI',
    locales: ['en-VI'],
    name: 'Virgin Islands (U.S.)'
  },
  {
    alpha2: 'AX',
    alpha3: 'ALA',
    currency: 'EUR',
    currency_name: 'Euro',
    default_locale: 'sv',
    locales: ['sv'],
    name: 'Åland Islands'
  },
  {
    alpha2: 'XK',
    alpha3: 'XKX',
    currency: 'EUR',
    currency_name: 'Euro',
    default_locale: 'sq',
    locales: ['sq'],
    name: 'Kosovo'
  }
];

export const formatCurrency = (value, currencyCode) => {
  return currencyFormatter.format(value, { code: currencyCode });
};

export const getLocaleCode = (countryCode) => {
  const country = locales.find((elem) => {
    return elem.alpha3 === countryCode || elem.alpha2 === countryCode;
  });
  return country.default_locale || 'en-US';
};
